<template lang="pug">
el-container.main
  LaunchHistory(style="padding-top: 20px;")
  .main-content(style="padding: 0;padding-top: 20px;")
    el-card(style="width: 100%;")
      .clearfix(slot="header")
        span.charts-title 国内/外发射数据统计
        el-date-picker(
          v-model="year",
          style="width: 110px;",
          type="year",
          size="mini",
          placeholder="选择年"
        )
      .row
        Echarts(:option="launchOption", width="100%", height="300px")
</template>

<script>
// @ is an alias to /src
import LaunchHistory from "./LaunchHistory.vue";
import Echarts from "@/components/Echarts";
import { getLaunchStatistics } from "@/services";
const getOption = function () {
  return {
    tooltip: {},
    xAxis: {
      type: "category",
      axisLabel: {
        interval: 0, //让所有坐标值全部显示
        align: "center",
        fontSize: 10,
        margin: 20,
      },
      data: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yAxis: {},
    series: [
      {
        name: "国外发射次数",
        type: "bar",
        stack: "launch",
        barWidth: "30%",
        itemStyle: {
          normal: {
            color: "#357AE7",
          },
        },
        data: [],
      },
      {
        name: "中国发射次数",
        type: "bar",
        stack: "launch",
        barWidth: "30%",
        itemStyle: {
          normal: {
            color: "#DE2910",
          },
        },
        data: [],
      },
      {
        name: "国外卫星发射数量",
        type: "bar",
        stack: "satellite",
        barWidth: "30%",
        itemStyle: {
          normal: {
            color: "#ED9B28",
          },
        },
        data: [],
      },
      {
        name: "中国卫星发射数量",
        type: "bar",
        stack: "satellite",
        barWidth: "30%",
        itemStyle: {
          normal: {
            color: "#4FA84F",
          },
        },
        data: [],
      },
    ],
    grid: {
      top: "5%",
      bottom: "5%",
      left: "5%",
      right: "5%",
      containLabel: true,
    },
  };
};
export default {
  name: "launch",
  components: {
    LaunchHistory,
    Echarts,
  },
  data() {
    return {
      loading: false,
      year: null,
      launchOption: null,
    };
  },
  watch: {
    year: {
      handler(val) {
        this.fetch();
      },
    },
  },
  methods: {
    async fetch() {
      this.loading = true;
      this.launchOption = getOption({});
      let year = new Date(this.year).getFullYear();
      const res = await getLaunchStatistics(
        this._.pickBy({ year: year }, this._.identity)
      );
      this.year = res.data["year"].toString();
      this.launchOption.series[0].data = res.data["ForeignLaunch"];
      this.launchOption.series[1].data = res.data["ChinaLaunch"];
      this.launchOption.series[2].data = res.data["ForeignSatellite"];
      this.launchOption.series[3].data = res.data["ChinaSatellite"];
      this.loading = false;
    },
  },
  mounted() {
    this.year = new Date();
    this.fetch();
  },
};
</script>
<style lang="stylus" scoped>
.row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}

.row .charts-title {
  flex-grow: 1;
  color: #999;
}

.el-date-editor {
  float: right;
  margin-top: -3px;
}
</style>
